import React, { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import ProcessMessagesTable from "./ProcessMessagesTable";

// ===== I18N =====
import { useTranslation } from "react-i18next";

export default function MessageLogCell({ messages = [] }) {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const chipBg = (color, pastelBg) => (isDark ? alpha(color, 0.18) : pastelBg);

  const hasError = messages.some(
    (m) => String(m.status_message).toUpperCase() === "E"
  );

  if (!hasError) return null;

  return (
    <>
      <Tooltip title={t("log.title")}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
          }}
        >
          <Box
            onClick={(e) => {
              e.stopPropagation();
              setOpen(true);
            }}
            sx={{
              width: 22,
              height: 22,
              borderRadius: "50%",
              backgroundColor: chipBg("#ef4444", "#fee2e2"),
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              flexShrink: 0,
              "&:hover": { backgroundColor: isDark ? alpha("#ef4444", 0.28) : "#fecaca" },
            }}
          >
            <Typography sx={{ fontSize: 13, fontWeight: 700, color: "#ef4444", lineHeight: 1 }}>
              !
            </Typography>
          </Box>
        </Box>
      </Tooltip>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{ sx: { borderRadius: "16px", overflow: "hidden" } }}
      >
        <DialogTitle sx={{ pb: 1.5, borderBottom: "1px solid", borderColor: "divider" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <Box sx={{ bgcolor: chipBg("#2563eb", "#eff6ff"), p: 0.8, borderRadius: "8px", display: "flex" }}>
              <MailOutlineIcon sx={{ fontSize: 18, color: isDark ? "primary.main" : "#2563eb" }} />
            </Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 800, color: "text.primary" }}>
              {t("log.subtitle")}
            </Typography>
          </Box>
        </DialogTitle>

        <DialogContent sx={{ p: 0 }}>
          <ProcessMessagesTable messages={messages} />
        </DialogContent>

        <DialogActions sx={{ px: 3, py: 1.5, borderTop: "1px solid", borderColor: "divider" }}>
          <Button
            variant="outlined"
            color="inherit"
            onClick={() => setOpen(false)}
            sx={{ border: "1px solid", borderColor: "divider", px: 3, textTransform: "none", fontWeight: 600 }}
          >
            {t("buttons.bClose")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}